import React from 'react'

const FinancialSummary = ({ plan, setEditedPlan, editable = false }) => {
  const handleChange = (field, value) => {
    if (!editable) return
    setEditedPlan(prev => ({ ...prev, [field]: value }))
  }

  const renderField = (field, label) => {
    const value = plan?.[field] || ''
    if (editable) {
      return (
        <div key={field}>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.25rem' }}>{label}</label>
          <input
            type="text"
            value={value}
            onChange={(e) => handleChange(field, e.target.value)}
            style={{
              width: '100%',
              padding: '0.4rem',
              fontSize: '0.85rem',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>
      )
    }
    return (
      <div key={field}>
        <strong>{label}:</strong> {value || '—'}
      </div>
    )
  }

  return (
    <div style={{ flex: 1, background: '#f8fafc', padding: '0.75rem', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
      <div style={{ display: 'flex', gap: '2rem', fontSize: '0.85rem' }}>
        {/* Deductibles */}
        <div style={{ flex: 1 }}>
          <h4 style={{ fontSize: '1rem', marginBottom: '0.75rem', marginTop: 0 }}>Deductibles</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {[
              ['deductible_individual', 'Individual'],
              ['deductible_family', 'Family'],
              ['deductible_applies_to_preventive', 'Applies to Preventive'],
              ['orthodontic_deductible', 'Ortho Deductible'],
            ].map(([field, label]) => renderField(field, label))}
          </div>
        </div>

        {/* Maximums */}
        <div style={{ flex: 1 }}>
          <h4 style={{ fontSize: '1rem', marginBottom: '0.75rem', marginTop: 0 }}>Maximums</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {[
              ['annual_maximum_individual', 'Annual Max (Individual)'],
              ['annual_maximum_family', 'Annual Max (Family)'],
              ['orthodontic_lifetime_maximum', 'Ortho Lifetime Max'],
            ].map(([field, label]) => renderField(field, label))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FinancialSummary
